<style scoped>
  .comment-words >>> textarea.ivu-input{height: 128px;margin: 40px 0 24px 0;resize:none}
  .art{height: 36px;width: 36px;border-radius: 18px;background-color: #00a2e9;font-size: 18px;color: #ffffff;text-align: center;line-height: 34px;cursor: pointer;}
  .comment-content{color: #525866;font-size: 14px;text-indent:1em;line-height: 40px}
</style>

<template>
  <div>
    <Row style="margin-bottom: 18px;">
      <Col span="24">
        <Input class="comment-words" v-model="commitText" type="textarea" :rows="4" placeholder="请输入评论内容"/>
      </Col>
      <Col span="12">
        <!--<div class="art">@</div>-->
        <div>&nbsp;</div>
      </Col>
      <Col span="12">
        <Button @click="sendComment()" size="large" type="primary" shape="circle" style="width: 100px;height: 36px;float: right;">发送</Button>
      </Col>
    </Row>
    <!--时间、内容-->
    <Row>
      <Col span="24" style="border-bottom: 1px solid #d7dde4;font-size: 0;padding-bottom: 10px" v-for="(item,index) in list">
        <Col span="24" style="color: #00a2e9;font-size: 14px;font-weight: bold;padding-top: 22px">{{item.date}}</Col>
        <template v-for="(secItem,secIndex) in item.children">
          <Col span="24" class="comment-content">{{secItem.time}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{secItem.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{secItem.content}}</Col>
        </template>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "comment",//评论
    data() {
      return {
        commitText:'',
        list:[],
      }
    },
    methods:{
      getComment:function () {
        var _this = this
        _this.send({
          headers:'E/ShowMessage',
          data:{
            CaseId: _this.$route.query.caseId,
          },
          success:function (res) {
            var i = 0
            for(var index in res){
              _this.$set(_this.list,i,{})
              _this.$set(_this.list[i],'date',index)
              _this.$set(_this.list[i],'children',[])
              var j = 0
              for(var secIndex in res[index]){
                _this.$set(_this.list[i].children,j,{})
                _this.$set(_this.list[i].children[j],'time',res[index][secIndex].MessageCreatedTime)
                _this.$set(_this.list[i].children[j],'name',res[index][secIndex].UserName)
                _this.$set(_this.list[i].children[j],'content',res[index][secIndex].MessageContent)
                _this.$set(_this.list[i].children[j],'id',res[index][secIndex].MessageId)
                j++
              }
              i++
            }
          }
        })
      },
      sendComment:function () {
        var _this = this
        _this.send({
          headers:'E/AddMsg',
          data:{
            CaseId: _this.$route.query.caseId,
            MessageContent:_this.commitText,
            MessageCreaterId:window.sessionStorage.userId,
          },
          success:function (res) {
            _this.getComment()
            _this.$Notice.success({
              title:'系统消息',
              desc:'评论成功！'
            })
          }
        })
      }
    },
    mounted:function () {
      this.getComment()
    }
  }
</script>

